/* eslint-disable */
import React from 'react'
import Chip from '@material-ui/core/Chip'
import Avatar from '@material-ui/core/Avatar'
import StyledHourglassFullIconComponent from './StyledHourglassFullIcon.component'
import pendingChipStyles from './PendingChip.component.styles'
import HourglassFullIcon from '@material-ui/icons/HourglassFull'
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import { withStyles } from '@material-ui/core'

function PendingChip(props) {
	const { classes } = props
  return <Chip
		className={classes.chip}
		avatar={
      <StyledHourglassFullIconComponent size='lg' />
		}
    label='Applying Changes'
		color='primary'
		variant='outlined'
  />
}

export default withStyles(themeCreateInjectableStyles(pendingChipStyles), { withTheme: true })(PendingChip)
